/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

import { Link, useLocation, useNavigate } from "react-router-dom";

import PropTypes from "prop-types";

import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";
import HomeIcon from '@mui/icons-material/Home';
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Toolbar from "@mui/material/Toolbar";

import MDBox from "components/MDBox";
import NotificationItem from "examples/Items/NotificationItem";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarIconButton,
  navbarMobileMenu,
  navbarRow,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import { MenuItem, Tooltip } from "@mui/material";
import axios from "axios";
import MDTypography from "components/MDTypography";
import LogoutModal from "components/logoutModal/logoutModal";
import {
  setMiniSidenav,
  setOpenConfigurator,
  setTransparentNavbar,
  useMaterialUIController,
} from "context";
import { useDispatch } from "react-redux";
import { appConstants } from "utils/appConstants";
import { showResMsg } from "utils/generic";
import Notifications from "./notification";
import BasicFeedbackModal from "components/displayModel/feedbackModal";
import { validateField } from "utils/generic";
import { sendFeedback } from "utils/api";
import { genericMessage } from "utils/genericMessages";
const errMsg = {
  color: `red`,
  fontSize: `11px`,
};
let LOGIN_DETAILS;
let EMPLOYEE_DETAILS;

function DashboardNavbar({ absolute, light, isMini, onSearchChange, ...props }) {
  const [navbarType, setNavbarType] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [showModal, setshowModal] = useState(false);
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchValue(value);
    onSearchChange(value);
  };
  const [credits, setCredits] = useState("");
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [key, setRoute] = useState("");
  const [detailsErr, setDetailsErr] = useState();
  const navigate = useNavigate();
  // const dispatch = useDispatch();
  // const dispatch1 = useDispatch();

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/").slice(1)[0];
    setRoute(path);
  }, [location.pathname]);

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenMenu = (event) => setOpenMenu(event.currentTarget);
  const handleCloseMenu = () => setOpenMenu(false);
  const dispatch1 = useDispatch()
  const [logoutDialogeFlag, setLogoutDialogeFlag] = useState(false);
  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem icon={<Icon>email</Icon>} title="Check new messages" />
      <NotificationItem icon={<Icon>podcasts</Icon>} title="Manage Podcast sessions" />
      <NotificationItem icon={<Icon>shopping_cart</Icon>} title="Payment successfully completed" />
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });

  };
  const handleHelpClick = () => {
    navigate("/help");
  };

  const handleHomeClick = () => {
    navigate("/dashboard");
  };

  const [values, setValues] = React.useState({
    userId: "",
    activityName: "",
    webAppUrl: "",
    ipAddress: "",
    defaultLocation: "",
  });

  LOGIN_DETAILS = JSON.parse(sessionStorage.getItem('LOGIN_DETAILS'));
  values.businessUserID = LOGIN_DETAILS.businessUserID;
  if (LOGIN_DETAILS.userType === "Warehouse") {
    EMPLOYEE_DETAILS = JSON.parse(sessionStorage.getItem('Employee_Details'));
    if (EMPLOYEE_DETAILS.warehouseName !== "" && EMPLOYEE_DETAILS.warehouseName !== undefined) {
      values.warehouseName = EMPLOYEE_DETAILS.warehouseName;
      values.city = EMPLOYEE_DETAILS.city;
    }
  }

  useEffect(() => {
    fetchCredit()
  }, [])
  const fetchCredit = async () => {
    await axios.post(appConstants.baseURL + 'login/fetchCredit', values)
      .then(
        (res) => {
          // console.log("respo", res.data)
          setCredits(res.data?.Result_Output[0]?.availableCredits)
          sessionStorage.setItem('CREDITS', JSON.stringify(res.data?.Result_Output[0]?.availableCredits));
        }
      )
      .catch(

        (error) => { console.log("Error in fetchCustomer=", error.message) }
      );

  }
  const logout = async e => {
    sessionStorage.clear();
    navigate("/login");
    // let payload = {
    //   themeValue: darkMode,
    //   userID: LOGIN_DETAILS._id
    // };
    // await axios.post(appConstants.baseURL + "themeSettings/themesSetting", payload).then(res => {
    //   if (res.data.Result_Status) {
    //     sessionStorage.clear();
    //     navigate("/login");
    //   } else {
    //     showResMsg(res.data.Result_Message, 2000, false);
    //   }
    // });
  }

  const handleFeedbackClick = () => {
    setshowModal(!showModal);
  };
  const handleSave = () => {

    const hasError = validateField(values.details, setDetailsErr);
    if (hasError) return;

    sendFeedback(
      values,
      (data) => {
        console.log("data333", data);
        if (data?.Result_Status) {
          showResMsg("Feedback Sent to Admin", 1000, true);

          setValues(prev => ({ ...prev, details: "" }));
          setshowModal(false); // ✅ close modal ONLY on success

          setTimeout(() => {
            navigate('/dashboard');
          }, 3000);
        } else {
          showResMsg(
            "Failed to send feedback",
            2000,
            false
          );
        }
      },
      dispatch
    );
  };

  // const handleSave = async () => {
  //   let mandateFlag = false;
  //   mandateFlag = validateField(values.details, setDetailsErr) || mandateFlag;
  //   if (mandateFlag) return;
  //   sendFeedback(
  //     values,
  //     (data) => {
  //       if (data?.Result_Status) {
  //         showResMsg("Feedback Sent to Admin", 1000, true);
  //         setValues(prev => ({ ...prev, details: "" }));

  //         setshowModal(false); // ✅ close modal ONLY on success

  //         setTimeout(() => {
  //           navigate('/dashboard');
  //         }, 3000);
  //       } else {
  //         showResMsg(data?.Result_Message, 2000, false);
  //       }
  //     },
  //     dispatch
  //   );
  // };

  // const handleSave = () => {
  //   let mandateFlag = false;
  //   mandateFlag = validateField(values.details, setDetailsErr) || mandateFlag;
  //   if (mandateFlag) {
  //     return;
  //   }
  //   sendFeedback(values, (data) => {
  //     setshowModal(false)
  //     if (data.Result_Status) {
  //       showResMsg(genericMessage.added, 1000, data.Result_Status);
  //       setValues({ ...values, details: "" });
  //     } else {
  //       showResMsg(data.Result_Message, 2000, data.Result_Status);
  //     }
  //   }, dispatch);
  // }


  const handlelogoutDialogeClick = async () => {
    setLogoutDialogeFlag(!logoutDialogeFlag);
  };

  const handleCancel = (name) => (event) => {
    setLogoutDialogeFlag(false);
  };

  const handleLogout = async (id) => {

    if (darkMode === true) {
      localStorage.setItem("ROUTE_TYPE", "trueDarkMode")
    } else {
      localStorage.setItem("ROUTE_TYPE", "falseDarkMode")
    }
    logout();
    setLogoutDialogeFlag(!logoutDialogeFlag);
  };


  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        <MDBox color="inherit" sx={(theme) => navbarRow(theme, { isMini })}>
          {/* {props.screenName} */}
          {LOGIN_DETAILS.userType === "Warehouse" &&
            <MDTypography variant="h6" color="dark">Warehouse Name: {values.warehouseName} ({values.city})</MDTypography>
          }

        </MDBox>
        {isMini ? null : (
          <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
            {LOGIN_DETAILS.userType === "Business" &&
              <>
                <MDBox pr={1}>
                  <MDTypography variant="h6" style={{ fontSize: '12px', cursor: "pointer" }} className={darkMode ? "darkPopup1" : "whitePopup1"} onClick={() => navigate("/subscriptions/viewCredits")}>Available Credits: {credits} &nbsp;&nbsp;</MDTypography>
                </MDBox>
                <Tooltip title="Feedback" arrow>
                  <IconButton
                    size="medium"
                    disableRipple
                    color="inherit"
                    sx={navbarIconButton}

                    onClick={handleFeedbackClick}
                  >
                    <Icon sx={iconsStyle} className={darkMode ? "darkPopup1" : "whitePopup1"}> feedback</Icon>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Help" arrow>
                  <IconButton
                    size="medium"
                    disableRipple
                    color="inherit"
                    sx={navbarIconButton}

                    onClick={handleHelpClick}
                  >
                    <Icon sx={iconsStyle} className={darkMode ? "darkPopup1" : "whitePopup1"}> help_outline</Icon>
                  </IconButton>
                </Tooltip>
                <Tooltip title="Home" arrow>
                  <IconButton
                    size="medium"
                    disableRipple
                    color="inherit"
                    sx={navbarIconButton}

                    onClick={handleHomeClick}
                  >
                    <HomeIcon sx={iconsStyle} className={darkMode ? "darkPopup1" : "whitePopup1"}> HomeIcon</HomeIcon>
                  </IconButton>
                </Tooltip>
              </>
            }

            <Notifications />

            <MDBox color={light ? "white" : "inherit"}>
              <Tooltip title="Settings" arrow>
                <IconButton
                  size="medium"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}

                  onClick={handleConfiguratorOpen}
                >
                  <Icon sx={iconsStyle} className={darkMode ? "darkPopup1" : "whitePopup1"}> settings</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Profile" arrow>
                <IconButton
                  sx={navbarIconButton}
                  size="medium"
                  disableRipple
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <Icon sx={iconsStyle} className={darkMode ? "darkPopup1" : "whitePopup1"}> account_circle</Icon>
                </IconButton>
              </Tooltip>
              {open && <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <Link to={"/editprofile"}>
                  <MenuItem>Profile</MenuItem>
                </Link>
                <MenuItem onClick={handlelogoutDialogeClick}>Logout</MenuItem>
              </Menu>}

              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="large">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
              {renderMenu()}
            </MDBox>
            <LogoutModal
              open={logoutDialogeFlag}
              handleLogout={handleLogout}
              handleCancel={handleCancel("handleCancel")}
              closeModalClick={handleCancel("closeModalClick")}
            />
            {showModal && <BasicFeedbackModal
              open={showModal}
              handleClose={() => { setshowModal(false); setValues({ ...values, details: "" }); }}
              value={values.details}
              onChange={handleChange("details")}
              handleSave={handleSave}
              errText={detailsErr ? <span style={errMsg}>Feedback can't be blank</span> : ""}

            />}
          </MDBox>
        )
        }

      </Toolbar >
    </AppBar >
  );
};

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
